var _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconpassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6756 0H5.33333C1.92889 0 0 1.92889 0 5.33333V14.6667C0 18.0711 1.92889 20 5.33333 20H14.6756C18.08 20 20 18.0711 20 14.6667V5.33333C20 1.92889 18.08 0 14.6756 0Z",
    fill: "#D0D3DB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 10,
    width: 7,
    height: 4,
    fill: "#8A92A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5C8.27614 12.5 8.5 12.2761 8.5 12C8.5 11.7238 8.27614 11.5 8 11.5C7.72386 11.5 7.5 11.7238 7.5 12C7.5 12.2761 7.72386 12.5 8 12.5Z",
    fill: "#D0D3DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12C10.5 12.2761 10.2761 12.5 10 12.5C9.72385 12.5 9.5 12.2761 9.5 12C9.5 11.7238 9.72385 11.5 10 11.5C10.2761 11.5 10.5 11.7238 10.5 12Z",
    fill: "#D0D3DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7238 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7238 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z",
    fill: "#D0D3DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8V9C6.17158 9 5.5 9.67155 5.5 10.5V13.5C5.5 14.3284 6.17158 15 7 15H13C13.8285 15 14.5 14.3284 14.5 13.5V10.5C14.5 9.67155 13.8285 9 13 9V8C13 6.34314 11.6568 5 10 5C8.34314 5 7 6.34314 7 8ZM7 10H13C13.2761 10 13.5 10.2238 13.5 10.5V13.5C13.5 13.7761 13.2761 14 13 14H7C6.72386 14 6.5 13.7761 6.5 13.5V10.5C6.5 10.2238 6.72386 10 7 10ZM12 8V9H8V8C8 6.89543 8.89543 6 10 6C11.1045 6 12 6.89543 12 8Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconpassword);
export default __webpack_public_path__ + "static/media/Icon.password.f7bae9f5fdefc75e969164350d34d2b7.svg";
export { ForwardRef as ReactComponent };